"use strict";function createStyles(e){return e}Object.defineProperty(exports,"__esModule",{"value":!0}),exports.default=createStyles;